import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, " Справочник содержит различные схемы для расчета допустимых продольных и поперечных смещений центра тяжести пакетов в контейнере. ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pt-2" }, " Допускаемое продольное смещение определяется таблицей в зависимости от общей массы пакетов в контейнере. Для промежуточных значений массы пакетов допускаемые смещения определяются линейной интерполяцией. Для значений массы пакетов меньших определенных в таблице берется значение допустимого смещения с минимальной массой. Для значений массы пакетов больших определенных в таблице берется значение допустимого смещения с максимальной массой. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pt-2" }, " Допускаемое поперечное смещение определяется таблицей в зависимости от общей массы пакетов в контейнере и высоты общего центра тяжести контейнера с пакетами относительно нулевой отметки Для промежуточных значений массы пакетов и высота общего ЦТ контейнера с пакетами допускаемые поперечные смещения определяются линейной интерполяцией. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoDialog = _resolveComponent("InfoDialog")!

  return (_openBlock(), _createBlock(_component_InfoDialog, {
    title: "Справка: Смещения",
    ref: "dialog"
  }, {
    infoForm: _withCtx(({}) => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }, 512))
}